export default "__VITE_ASSET__CSl4Hbhs__"